var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHappeningBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0559082,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#6B40ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4187 21.376H19.4956C20.926 21.376 21.6709 20.6377 21.6709 19.2271V11.2048C21.6709 9.79419 20.926 9.05591 19.4956 9.05591H10.4187C8.99487 9.05591 8.25 9.7876 8.25 11.2048V19.2271C8.25 20.6377 8.99487 21.376 10.4187 21.376ZM10.4121 20.0642C9.86499 20.0642 9.56177 19.7808 9.56177 19.2007V13.1362C9.56177 12.5562 9.86499 12.2727 10.4121 12.2727H19.5022C20.0493 12.2727 20.3525 12.5562 20.3525 13.1362V19.2007C20.3525 19.7808 20.0493 20.0642 19.5022 20.0642H10.4121Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8098 13.3913C14.8697 13.2071 15.1303 13.2071 15.1902 13.3913L15.797 15.2589C15.8238 15.3413 15.9006 15.3971 15.9872 15.3971H17.9509C18.1447 15.3971 18.2252 15.645 18.0685 15.7589L16.4798 16.9131C16.4097 16.9641 16.3804 17.0543 16.4072 17.1367L17.014 19.0043C17.0739 19.1886 16.863 19.3418 16.7062 19.2279L15.1176 18.0737C15.0475 18.0228 14.9525 18.0228 14.8824 18.0737L13.2938 19.2279C13.137 19.3418 12.9261 19.1886 12.986 19.0043L13.5928 17.1367C13.6196 17.0543 13.5903 16.9641 13.5202 16.9131L11.9315 15.7589C11.7748 15.645 11.8553 15.3971 12.0491 15.3971H14.0128C14.0994 15.3971 14.1762 15.3413 14.203 15.2589L14.8098 13.3913Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappeningBadge);
export default __webpack_public_path__ + "static/media/happening-badge.97b89b83209e1e0cf5eda424bc82b19e.svg";
export { ForwardRef as ReactComponent };